
import { MixedVue, mixins } from "@/vue";
import { logMessage, propsInstance } from "../../lib/util";

const Props = propsInstance<{
  errorCode: number;
}>({
  errorCode: { type: Number, required: true },
});

export default class ErrorPage extends mixins(MixedVue, Props) {
  errorMessage = "";

  created() {
    switch (this.errorCode) {
      case 403:
        this.errorMessage = this.$gettext("You don't have access to this link");
        break;
      default:
        logMessage(`Unknown error: ${this.errorCode}`);
        this.errorMessage = this.$gettext("That's embarrassing, something went wrong. We're looking into it.");
    }
  }

  goHome() {
    window.location.href = window.location.origin;
  }
}
